// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__6Ues0","textContainer":"styles_textContainer__28gJ_","title":"styles_title__2pkpt","description":"styles_description__3lk08"};